module.exports = __webpack_public_path__ + "static/media/COnnessione REVCON_Stampa1.dc3a9c89.png";